import { Children, useCallback, useRef, useState } from 'react'
import useEnterStagger from './hooks/useEnterStagger.js'

// Structural kanban rail. DnD is the caller's concern; the kit does layout,
// phone scroll-snap, and position dots.
export function BoardRail({ className = '', children, innerRef, ...rest }) {
  const railRef = useRef(null)
  const [active, setActive] = useState(0)
  const count = Children.count(children)
  useEnterStagger(railRef, { dep: count, selector: ':scope > .cn-board-col' })
  // Stable identity so React doesn't detach/reattach the ref every render.
  const setRefs = useCallback((el) => {
    railRef.current = el
    if (typeof innerRef === 'function') innerRef(el)
    else if (innerRef) innerRef.current = el
  }, [innerRef])
  const onScroll = () => {
    const el = railRef.current
    if (!el || !el.firstElementChild) return
    const colWidth = el.firstElementChild.offsetWidth + 10
    setActive(Math.max(0, Math.min(count - 1, Math.round(el.scrollLeft / colWidth))))
  }
  return (
    <div className="cn-board-shell">
      <div ref={setRefs} className={`cn-board ${className}`.trim()} onScroll={onScroll} {...rest}>
        {children}
      </div>
      <div className="cn-board-dots" aria-hidden="true">
        {Array.from({ length: count }, (_, i) => (
          <span key={i} className="cn-board-dot" data-active={i === active ? 'true' : 'false'} />
        ))}
      </div>
    </div>
  )
}

export function BoardColumn({ title, count, accent, actions, footer, className = '', children, ...rest }) {
  return (
    <div {...rest} className={`cn-board-col ${className}`.trim()} style={accent ? { '--board-accent': accent } : undefined}>
      <div className="cn-board-col-head">
        <span className="cn-board-col-title">{title}</span>
        {count != null && <span className="cn-board-col-count">{count}</span>}
        {actions}
      </div>
      <div className="cn-board-col-body">{children}</div>
      {footer && <div className="cn-board-col-foot">{footer}</div>}
    </div>
  )
}
